import * as Sentry from '@sentry/vue';
import type { IAdapter, InitArguments } from '../event-client';
import type { EventPayloads, EventTypes, LoginPayload } from '../events';
import { onLoad } from '../utils';

// eslint-disable-next-line unused-imports/no-unused-vars
const loadGtm = async (arg: InitArguments['gtm']) => {
	onLoad(async () => {
		const script = document.createElement('script');
		script.async = true;
		script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer','${arg.containerId}');`;

		document.head.appendChild(script);
		await new Promise((resolve, reject) => {
			const timeOutId = setTimeout(() => {
				Sentry.captureException('Timeout while loading gtm script', (scope) => {
					scope.setContext('error', {
						message: 'Timeout while loading gtm script',
					});
					return scope;
				});
				script.remove();
				reject(1);
			}, 3000);
			script.onload = () => {
				clearTimeout(timeOutId);
				resolve(1);
			};
			script.onerror = (e) => {
				console.log('Failed to load gtm script: script.onerror', e);
				Sentry.captureException('Failed to load gtm script', (scope) => {
					scope.setContext('error', {
						message: e.toString(),
					});
					return scope;
				});
				script.remove();
				reject(1);
			};
		});
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${arg.containerId}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		document.body.appendChild(iframe);
	});
};

export class GtmAdapter implements IAdapter {
	name: string = 'gtm';
	queue: Array<{ name: EventTypes; data: EventPayloads[EventTypes] }> = [];

	async init(arg: InitArguments['gtm']): Promise<void> {
		let retry = 1;
		while (retry >= 0) {
			try {
				await loadGtm(arg);
				break;
			} catch (e: any) {
				console.log('Failed to load Gtm script', e.message);
				retry--;
			}
		}
		// @ts-ignore
		window.dataLayer = window.dataLayer || [];
		// @ts-ignore
		window.gtm = function () {
			// @ts-ignore
			// eslint-disable-next-line prefer-rest-params
			window.dataLayer?.push(arguments);
		};
		// @ts-ignore
		window.gtm('js', new Date());
		// @ts-ignore
		window.gtm('config', arg.containerId);
	}

	sendEvent(name: EventTypes, data: EventPayloads[EventTypes]): void {
		console.log(`GTM Adapter received event: ${name}`, data);
	}

	login(data: LoginPayload): void {
		// @ts-ignore
		if (!window.gtm) {
			return;
		}
		// @ts-ignore
		window.gtm('set', 'container_id', data);
	}
	logout(): void {
		// @ts-ignore
		if (!window.gtm) {
			return;
		}
		// @ts-ignore
		window.gtm('set', 'container_id', {});
	}
}
